// extracted by mini-css-extract-plugin
export default {"hideTooltip":"b--z","fadeIn":"c--z","delay":"d--z","recommendedSizeTooltip":"e--z"};